import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import routes from './routes/routes'

Vue.config.productionTip = false

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes
});

new Vue({
  render: h => h(App),
  router,
  data: {
    apiUrl: process.env.VUE_APP_API_URL,
    newApiUrl: process.env.VUE_APP_NEW_API_URL
  }
}).$mount('#app')

Vue.config.errorHandler = (err, vm) => {
  var url = new URL(window.location.href.replace('/#', ''))
  var xhr = new XMLHttpRequest()
  var formData = new FormData()
  var obj = {
    experiment_id: vm.$parent.experiment.id,
    experiment_name: vm.$parent.experiment.name,
    experiment_slug: vm.$parent.experiment.slug,
    experiment_status: vm.$parent.experiment.status,
    section_name: vm.screen.sectionName,
    screen_name: vm.screen.name,
    origin: 'main error handler',
    error: err,
    url: url.pathname + url.search,
    ua: '-'
  }
  Object.keys(obj).forEach(key => {
    formData.append(key, obj[key])
  })
  xhr.open('POST', process.env.VUE_APP_API_URL + 'v1/felerjs/')
  xhr.send(formData)
}
